import { memo } from 'react';
import { IConditionBase } from '@tymely/atoms';

import { BaseConditionEditor, ConditionEditorProps } from './BaseConditionEditor';
import { PredicateButton } from './PredicateButton';

export const NoValueWithSpecialConditionEditor = memo((props: ConditionEditorProps<IConditionBase>) => {
    return <BaseConditionEditor {...props} />;
});

NoValueWithSpecialConditionEditor.displayName = 'NoValueWithSpecialConditionEditor';

export const NoValueConditionEditor = memo((props: ConditionEditorProps<IConditionBase>) => {
    return <PredicateButton {...props} fullWidth />;
});

NoValueConditionEditor.displayName = 'NoValueConditionEditor';
